import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom"; // no Router here
import "./App.css";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import AboutPage from "./pages/AboutPage";
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import AOS from "aos";
import "aos/dist/aos.css";
import CheckoutPage from "./pages/CheckoutPage";
import ProfilePage from "./pages/ProfilePage";
import { Toaster } from "react-hot-toast";
import CertificationPage from "./pages/CertificationPage";
import WhyBuyLatex from "./pages/WhyBuyLatex";
import MattressGuidePage from "./pages/MattressGuidePage";
import Reason8 from "./components/OtherPages/Reason8";
import SapToSleepPage from "./pages/SapToSleepPage";
import ContactPage from "./pages/ContactPage";
import FaqPage from "./pages/FaqPage";
import WarrantyPage from "./components/OtherPages/WarrantyPage";
import PrivacyPolicy from "./components/OtherPages/PrivacyPolicy";
import TermsCondition from "./components/OtherPages/TermsCondition";
import ProductListingPage from "./components/shop/ProductListingPage";
// import ShopOrganicPage from "./pages/ShopOrganicPage";
function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);
  return (
    <div>
      <Toaster />
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/eloris/mellow-soft-series" element={<ShopPage />} />
        {/* <Route path="/organic/ortho-latex-mattress" element={<ShopOrganicPage />} /> */}
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/certifications" element={<CertificationPage />} />
        <Route path="/why-buy-latex" element={<WhyBuyLatex />} />
        <Route path="/mattress-guide" element={<MattressGuidePage />} />
        <Route path="/sap-to-sleep" element={<SapToSleepPage />} />
        <Route path="/8-reason-to-choose" element={<Reason8 />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/warranty-coverage" element={<WarrantyPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-condition" element={<TermsCondition />} />
        <Route path="/shop" element={<ProductListingPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
